import { randomId } from '@shared/utils/guid.js'
import { defineStore } from 'pinia'

export const useRequest = defineStore('request', {
  state: () => ({
    requestId: null
  }),

  getters: {
    hasRequestId: (state) => state.requestId != null
  },

  actions: {
    stopRequestTransaction() {
      this.$reset()
    },
    startRequestTransaction() {
      this.requestId = randomId()
    }
  }
})
